export const CATALOG_ROUTINE_OPTIONS: string[] = ['Manhã', 'Noite', 'Manhã e Noite'];

export const CATALOG_CATEGORY_OPTIONS: string[] = [
  'limpeza',
  'tonico',
  'serum_tratamento',
  'contorno_olhos',
  'hidratante',
  'protetor_solar'
];
